function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M880.783 194.644C1019.85 152.139 1267.49 -20.2484 1462.82 2.29947C1658.15 24.8473 1859.52 255.329 2053.29 295.708C2247.06 336.087 2512.49 304.687 2585.94 405.301C2560.88 484.153 1933.99 642.381 1730.36 698.659C1535.22 752.593 1294.08 749.869 1067.7 764.723C863.569 778.117 655.392 799.227 478.049 780.831C291.388 761.468 139.013 720.113 63.8479 660.589C-11.8968 600.606 -20.4852 486.584 40.8149 413.6C101.986 340.77 277.478 222.277 505.012 231.404C732.546 240.531 741.718 237.149 880.783 194.644Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 1039.59,
  y1: 242.361,
  x2: 1041.92,
  y2: 413.545,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4B1C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7C81C0",
  stopOpacity: 0
})));

var SvgDownloadMobileAppStyling = function SvgDownloadMobileAppStyling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 935,
    height: 627,
    viewBox: "0 0 935 627",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadMobileAppStyling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_mobile_app_styling.ce65bd9c.svg";
export { ForwardRef as ReactComponent };